import React, { useEffect, useState } from "react";
import { useStore } from "../../Components/StateProvider"; // Re-added as per user's latest selection
import { getlocal } from "../../functions/localstorage";
import { ErrorAlert, GetRecords, SuccessAlert, URLPRIFIX, baseurl, getList, saveRecord } from "../../functions/api";
// Re-added as per user's latest selection

// Import React Icons for a modern look
import {
  FaFolder,
  FaBalanceScale, // Equivalent to Scale
  FaShieldAlt, // Equivalent to Shield
  FaClipboardList,
  FaUsers,
  FaCalendarCheck,
  FaDollarSign,
  FaRegChartBar, // Equivalent to Activity, a more general chart icon
  FaCheckCircle,
  FaHourglassHalf, // Equivalent to Hourglass
  FaArrowRight,
  FaRegDotCircle, // Equivalent to CircleDot
} from "react-icons/fa"; // Using Font Awesome icons from react-icons
import { TbHammer } from "react-icons/tb";
import axios from "axios";
import Dropdown from "../../Components/Fields/Dropdown";
import FileInput from "../../Components/Fields/FileInput";
import Attachement from "../../Components/Fields/Attachement";
import { Input } from "@mui/material";

const AssignTaskModal = ({ isOpen, onClose, onSubmit, assignedToUser }) => {
  const [title, setTitle] = useState('');
  const [projectType, setProjectType] = useState('');
  const [projectList, setProjectList] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [docfield, setDocField] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [documentName, setDocumentName] = useState('');
  const [priority, setPriority] = useState('Medium');
  const [dueDate, setDueDate] = useState('');
  const [description, setDescription] = useState('');
  const [attachments, setAttachments] = useState([]); // Support multiple

  const [sendNotification, setSendNotification] = useState(false);
  const store = useStore();
  const projectTypes = [
    { label: 'Non-Litigation', value: 11 },
    { label: 'Litigation', value: 12 },
    { label: 'Trademark', value: 13 },
    // { label: 'Advisory', value: 14 },
  ];
  const priorities = ['High', 'Medium', 'Low'];
  useEffect(() => {
    if (projectType) {
      GetProjectList();
    }
  }, [projectType]);
  useEffect(() => {
    if (projectName) {
      getDocumentList();
    }
  }, [projectName]);
  const handleSubmit = (e) => {
    e.preventDefault();
    const newTaskDetails = {
      title,
      assignedToUser,
      projectName,
      projectType,
      documentName,
      priority,
      dueDate,
      description,
      attachments: (store.getvalue("attachmenturl") || []).filter(Boolean),
      // attachments,
      sendNotification
    };
    onSubmit(newTaskDetails);
    onClose();
  };
  // const handleAttachmentChange = (e) => {
  //   const newFiles = Array.from(e.target.files);
  //   setAttachments(prev => [...prev, ...newFiles]);
  // };

  // const removeAttachment = (index) => {
  //   setAttachments(prev => prev.filter((_, i) => i !== index));
  // };


  if (!isOpen) return null;

  async function GetProjectList(client = {}) {
    console.log("GetProjectList client", client);

    await getList({
      listUrl: `/project/getprojectlist/${projectType}`,
      sort: "asc",
      count: 10000,
    }).then((projects) => {
      if (projects.success) {
        projects = projects?.data?.list || [];
        projects = projects.map((project) => ({
          ...project,
          value: project.id,
          label: project.projectName,
        }));
        // console.log("PRO:", projects);
        setProjectList(projects)
        setProjectName("")
        setDocumentName("")
      }
    });
  }
  async function getDocumentList() {
    await getList({
      listUrl: `/tasks/getprojectstasklist/${projectType}`,
      field: "project_id",
      search: projectName,
      count: 10000,
    }).then((task) => {
      if (task.success) {
        task = task?.data?.list || [];
        task = task.map((taskeach) => ({
          ...taskeach,
          value: taskeach.id,
          label: taskeach.task_title,
        }));
        setDocumentList(task)
        setDocField(task.length > 0);
        console.log("DOCUMENT", task);

      }
    });
  }
  // function projectNameChange(project_id) {
  //   if (project_id != "") {
  //     // GetRecords("/project/getproject/" + project_id + projectType).then(
  //     //   (project) => {
  //     //     if (project.success) {
  //     //       project = project?.record || {};
  //     //       console.log("projectNameChange", project);
  //     //       if (project.parent.category_id == 1) {
  //     //         store.setprops("form_id", { mandatory: true, readonly: true });
  //     //       } else {
  //     //         store.setprops("form_id", { hidden: true });
  //     //         store.setvalue("form_id", "0");
  //     //         console.log("form id check .........", store);
  //     //       }
  //     //       store.setvalue("contact_id", project.parent.contact_id);
  //     //       // GetArtistList(project.parent.contact_id, project.parent.film_id);
  //     //       // getDocumentList(project.parent.id);
  //     //     }
  //     //   }
  //     // );
  //   } else {
  //     store.setprops("form_id", { hidden: true });
  //   }
  // }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div
        className="rounded-xl shadow-2xl w-full"
        style={{
          maxWidth: '500px',
          maxHeight: '98vh',
          backgroundColor: '#FFFFFF',
          overflowY: 'auto',
          padding: '24px'
        }}
      >
        <h2 className="text-xl font-bold mb-6 text-center" style={{ color: '#111827' }}>
          Assign New Task to{" "}
          {assignedToUser?.name
            ? assignedToUser.name.charAt(0).toUpperCase() + assignedToUser.name.slice(1)
            : ""}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex gap-4">
            <div>
            <label htmlFor="title" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
              Task Title
            </label>
            <input
              id="subtaskTitle"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-2 rounded-md border resize-y"
              style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
              required
            />
          </div>
            <div className="w-1/2">
              <label htmlFor="projectType" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Project Type
              </label>
              <select
                id="projectType"
                value={projectType}
                onChange={(e) => setProjectType((e.target.value))}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required>
                <option value="">Select Type</option>
                {projectTypes.map((type) => (<option key={type.value} value={type.value}>{type.label}</option>))}
              </select>

              {/* <select
                id="projectType"
                value={projectType}
                onChange={(e) => setProjectType(e.target.value)}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
              >
                <option value="">Select Type</option>
                {projectTypes.map(type => <option key={type} value={type}>{type}</option>)}
              </select> */}
            </div>
            <div className="w-1/2">
              <label htmlFor="projectName" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Project Name
              </label>
              {/* <Dropdown
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
                name="project_id"
                list={store.getprops("projectName_list") || []}
                onchange={projectNameChange}
              /> */}
              <select
                id="projectName"
                value={projectName}
                onChange={(e) => { setDocumentName(""); setProjectName(e.target.value) }}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
              >
                <option value="">Select Project</option>
                {projectList.map(name => <option key={name.value} value={name.value}>{name.label}</option>)}
              </select>
            </div>
          </div>

          {/* Document Name */}

          <div className="flex gap-4">
            {docfield && (
              <div className="w-1/2">
                <label htmlFor="documentName" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                  Document Name
                </label>
                <select
                  id="documentName"
                  value={documentName}
                  onChange={(e) => setDocumentName(e.target.value)}
                  className="w-full text-sm p-2 rounded-md border"
                  style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                  required
                >
                  <option value="">Select Document</option>
                  {documentList.map(name => <option key={name.value} value={name.value}>{name.label}</option>)}
                </select>

              </div>
            )}
            {/* Priority */}
            <div className="w-1/2">
              <label htmlFor="priority" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Priority
              </label>
              <select
                id="priority"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
              >
                {priorities.map(prio => <option key={prio} value={prio}>{prio}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-4">
            {/* Due Date */}
            <div className="w-1/2">
              <label htmlFor="dueDate" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Due Date
              </label>
              <input
                type="date"
                id="dueDate"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
              />
            </div>
            <div className="w-1/2 flex items-center mt-1">
              <input
                type="checkbox"
                id="sendNotification"
                checked={sendNotification}
                onChange={(e) => setSendNotification(e.target.checked)}
                className="mr-2"
              />
              <label htmlFor="sendNotification" className="text-sm font-medium" style={{ color: '#374151' }}>
                Send Notification
              </label>
            </div>

          </div>
          <div>
            <label htmlFor="attachment" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
              Attachments
            </label>
            <div className="grid grid-cols-5">
              {store.getvalue("attachmenturl")?.length > 0 ? (
                store.getvalue("attachmenturl").map((item, index) => {
                  // console.log("test 223", item);
                  return (
                    <div className="col-span-1 flex border-r pr-6 w-full  items-center">
                      <Attachement name={"attachmenturl"} fileurl={item} />
                      <button
                        className="hover:bg-tertiary p-1 h-fit w-fit rounded-full"
                        onClick={() => {
                          let arr = [];
                          store
                            .getvalue("attachmenturl")
                            .map((attachitem, attachindex) => {
                              if (attachindex !== index) {
                                arr.push(attachitem);
                              }
                            });
                          store.setvalue("attachmenturl", arr);
                        }}
                      >
                        X
                      </button>
                    </div>
                  );
                })
              ) : (
                <>No Data</>
              )}
              <FileInput
                prefix={"TASK"}

                onchange={(file) => {
                  let attachmenturl = store.getvalue("attachmenturl") || [];
                  attachmenturl.push(file);
                  store.setvalue("attachmenturl", attachmenturl);
                }}
              />
            </div>
            {/* <input
              type="file"
              id="attachment"
              multiple
              onChange={handleAttachmentChange}
              className="w-full text-sm p-2 rounded-md border mb-2"
              style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
            /> */}
            {/* Attachment list with remove */}
            {/* <ul className="space-y-1">
              {attachments.map((file, index) => (
                <li key={index} className="flex items-center justify-between text-sm bg-gray-100 rounded px-2 py-1">
                  <span className="truncate">{file.name}</span>
                  <button
                    type="button"
                    onClick={() => removeAttachment(index)}
                    className="text-red-500 hover:text-red-700"
                    title="Remove"
                  >
                    ❌
                  </button>
                </li>
              ))}
            </ul> */}
          </div>

          {/* Description */}
          <div>
            <label htmlFor="description" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
              Description
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="3"
              className="w-full p-2 rounded-md border resize-y"
              style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
              required
            ></textarea>
          </div>
          

          {/* Buttons */}
          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2 rounded-md font-semibold transition-colors duration-200"
              style={{ backgroundColor: '#E5E7EB', color: '#374151' }}
            >
              Close
            </button>
            <button
              type="submit"
              className="px-5 py-2 rounded-md font-semibold transition-colors duration-200"
              style={{ backgroundColor: '#2563EB', color: '#FFFFFF' }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// Helper component for individual dashboard cards
const DashboardCard = ({ title, value, subtitle, icon: Icon, link, children, className = "" }) => (
  <div className={`bg-white rounded-xl shadow-lg p-6 flex flex-col justify-between transition-all duration-300 hover:shadow-xl hover:scale-[1.01] transform ${className}`}>
    <div>
      <div className="flex items-center mb-3">
        {/* Render the React Icon component */}
        {Icon && <Icon className="mr-3 text-blue-600 w-7 h-7" />}
        <h3 className="text-lg font-semibold" style={{ color: '#1F2937' }}>{title}</h3> {/* gray-800 */}
      </div>
      {value !== undefined && value !== null && (
        <p className="text-4xl font-bold" style={{ color: '#0f0061ff' }}>{value}</p> // gray-900
      )}

      {subtitle && <p className="text-sm" style={{ color: '#6B7280' }}>{subtitle}</p>} {/* gray-500 */}
      {children}
    </div>
    {link && (
      <button
        onClick={link} // Pass the 'link' function directly to onClick
        className="mt-4 font-medium self-end flex items-center text-blue-600 hover:underline focus:outline-none"
        style={{ color: '#2563EB' }} // blue-600
      >
        View All <FaArrowRight className="ml-1 w-4 h-4" />
      </button>
    )}
  </div>
);

// Main Dashboard Component
const DashboardNew = () => {
  const [loggedInUser, setLoggedInUser] = useState({
    username: 'Admin User', // Default mock user
    initials: 'AU' // Default initials
  });
  const user = getlocal("system")?.user || {};

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedUserForAssignment, setSelectedUserForAssignment] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userRole, setuserRole] = useState('');


  // Re-added useStore and init as per user's latest selection
  const store = useStore();
  const init = {
    assignTask: [],
    DocumentList: [],
    Duedatelistdoc: [],
    Schedulecal: "",
  };

  // Simulate initial setup (like store.setmodule, store.setheader, store.stopLoading)
  useEffect(() => {
    store.setmodule("dashboard", init);
    store.setheader("Hello, " + getlocal("system")?.user?.name);
    store.stopLoading();
    // In a real application, you'd fetch user data here
    // For now, we'll use a mock user
    setLoggedInUser({ username: 'Alice Smith', initials: 'AS' });
  }, []); // Added `store` and `init` to dependency array if they are stable or memoized

  useEffect(() => {
    const fetchDashboardData = () => {
      let token = getlocal("system").token;

      let role_id = getlocal("system")?.user?.role;
      console.log("check role***", role_id);
      // Simulate API call delay
      setTimeout(() => {
        // if (role_id != 1) {
        let url = "";
        url += "user_id=" + getlocal("system")?.user?.id;
        setuserRole(role_id);
        axios.get(`${baseurl}/api/Non_litigation_Dashboard/non-litigation-dashboard?${url}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
          .then((res) => {
            setDashboardData(res?.data)
            console.log("response for dashboard", res);
          })
        //     })
        // } else {
        //   axios.get(`${baseurl}/api/Non_litigation_Dashboard/non-litigation-dashboard`, {
        //     headers: { Authorization: `Bearer ${token}` }
        //   })
        //     .then((res) => {
        //       setDashboardData(res?.data)
        //       console.log("response for dashboard", res);
        //     })
        // }
        // const mockData = {
        //   projects: {
        //     nonLitigation: {
        //       active: 155,
        //       totalProjects: 70,
        //       documentsApproved: 20,
        //       documentsDraft: 493,
        //       documentsCompleted: 20,
        //       tasksPending: 16,
        //       tasksCompleted: 56
        //     },
        //     litigation: {
        //       active: 82,
        //       totalProjects: 15,
        //       approvedProjects: 70,
        //       statusCounts: {
        //         open: 5,
        //         closed: 10,
        //         onHold: 0
        //       },
        //       tasksTotal: 200,
        //       tasksApproved: 150
        //     },
        //     trademark: {
        //       registrations: 47,
        //       totalProjects: 42,
        //       approvedProjects: 40,
        //       statusCounts: {
        //         filed: 30,
        //         approved: 10,
        //         rejected: 2
        //       },
        //       tasksTotal: 80,
        //       tasksApproved: 70
        //     },
        //   },
        //   tasks: {
        //     assignedToMe: {
        //       total: 5,
        //       statusCounts: {
        //         pending: 3,
        //         completed: 2
        //       }
        //     },
        //     overallStatus: { // This section will be replaced with more granular views
        //       completed: 60,
        //       pending: 118,
        //       overdue: 2,
        //       total: 180
        //     },
        //     completedToday: 3,
        //     overdue: 2,
        //     totalActive: 180,
        //   },
        //   userWorkload: [
        //     // Added pendingTasks to mock data
        //     { id: 'user1', name: 'Alice Smith', tasks: 12, draft: 7, pendingTasks: 4, initials: 'AS' },
        //     { id: 'user2', name: 'Bob Johnson', tasks: 5, draft: 7, pendingTasks: 2, initials: 'BJ' },
        //     { id: 'user3', name: 'Charlie Brown', tasks: 18, draft: 7, pendingTasks: 7, initials: 'CB' },
        //     { id: 'user4', name: 'Diana Prince', tasks: 7, draft: 7, pendingTasks: 1, initials: 'DP' },
        //     { id: 'user5', name: 'Eve Adams', tasks: 15, draft: 7, pendingTasks: 5, initials: 'EA' },
        //     { id: 'user6', name: 'Frank Green', tasks: 10, draft: 7, pendingTasks: 3, initials: 'FG' },
        //     { id: 'user7', name: 'Grace Hall', tasks: 9, draft: 7, pendingTasks: 2, initials: 'GH' },
        //     { id: 'user8', name: 'Harry King', tasks: 14, draft: 7, pendingTasks: 6, initials: 'HK' },
        //   ],
        //   upcomingDeadlines: [
        //     { id: 'dl1', title: 'Review Legal Document', date: '2025-07-15', project: 'Litigation Case A', assignedTo: 'Alice Smith' },
        //     { id: 'dl2', title: 'File Trademark Application', date: '2025-07-18', project: 'Trademark Registrations', assignedTo: 'Bob Johnson' },
        //     { id: 'dl3', title: 'Prepare Client Brief', date: '2025-07-20', project: 'Non-Litigation Advisory', assignedTo: 'Charlie Brown' },
        //     { id: 'dl4', title: 'Invoice Client XYZ', date: '2025-07-22', project: 'Accounting', assignedTo: 'Diana Prince' },
        //     { id: 'dl5', title: 'Update Project Scope Doc', date: '2025-07-25', project: 'Non-Litigation Agreement', assignedTo: 'Eve Adams' },
        //   ],
        //   scheduleItems: [
        //     { id: 's1', title: 'Q3 Financial Review', time: '10:00 AM', date: '2025-07-15', location: 'Conference Room 3' },
        //     { id: 's2', title: 'Project Alpha Kickoff', time: '02:00 PM', date: '2025-07-16', location: 'Online Meeting' },
        //     { id: 's3', title: 'Client Demo', time: '04:00 PM', date: '2025-07-17', location: 'Client Office' },
        //   ],
        //   accountingSummary: {
        //     totalInvoiced: 125000.00,
        //     amountReceived: 98500.00,
        //     outstandingBalance: 26500.00,
        //     topClients: [
        //       { id: 'cl1', name: 'Global Corp', amount: 35000.00 },
        //       { id: 'cl2', name: 'Innovate Solutions', amount: 28000.00 },
        //       { id: 'cl3', name: 'Tech Pioneers', amount: 19000.00 },
        //       { id: 'cl4', name: 'MediCare Group', amount: 12000.00 },
        //       { id: 'cl5', name: 'Green Earth Inc.', amount: 9500.00 },
        //     ],
        //   },
        //   recentActivity: [
        //     { id: 'act1', text: 'Alice Smith completed task "Drafting Contract" for Non-Litigation Case.', time: '2 mins ago' },
        //     { id: 'act2', text: 'New document "Client Agreement v2" added to Litigation Case B by Bob Johnson.', time: '1 hour ago' },
        //     { id: 'act3', text: 'Invoice #INV-2025-001 generated for Client ABC.', time: '3 hours ago' },
        //     { id: 'act4', text: 'Charlie Brown assigned "Research Patent Law" to Diana Prince.', time: 'Yesterday' },
        //     { id: 'act5', text: 'Trademark application for "BrandSafe" updated by Eve Adams.', time: 'Yesterday' },
        //   ],
        // };

        // setDashboardData(mockData);
        setLoading(false);
      }, 1000); // 1 second delay
    };

    fetchDashboardData();
  }, []);
  const handleAssignTaskClick = (user) => {
    setSelectedUserForAssignment(user);
    setIsAssignModalOpen(true);
  };
  if (loading || !dashboardData) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-lg font-medium text-gray-700">Loading dashboard data...</div>
      </div>
    );
  }
  const filteredUsers = dashboardData?.userWorkload.filter(user =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];
  // const handleRowClick = (item) => {
  //   console.log("Row clicked:", item);
  //   if (store.getprops("view")) {

  //   }
  // };
  const handleTaskSubmit = (taskDetails) => {
    console.log("New Task Submitted:", taskDetails);
    const payload = {
      type: taskDetails.projectType,
      project_id: taskDetails.projectName,
      status: "Draft",
      subtask_title: taskDetails.title,
      assigned_to: taskDetails.assignedToUser.id,
      attachmenturl: taskDetails.attachments,
      dueDate: new Date(taskDetails.dueDate).toISOString(),
      priority: taskDetails.priority,
      description: taskDetails.description,
      createdBy: store.getuser().id,
      createdDate: new Date().toISOString(),
      ...(taskDetails.documentName && { task_id: taskDetails.documentName }),

    };
    // console.log("PAY:",payload);
    const setrecord = `/subtask/addsubtasks/${payload.type}`;
    saveRecord(setrecord, payload)
      .then((res) => {
        if (res.success) {
          console.log("Response of saveRecord:", res);
          SuccessAlert("Task Assigned Successfully");
        } else {
          console.error("Error response:", res);
          ErrorAlert("Unable to save the Task Assigned as unchoose. Please Choose assigned to Field");
        }
      })
    setDashboardData(prevData => {
      const updatedUserWorkload = prevData.userWorkload.map(user => {
        if (user.id === taskDetails.assignedToUser.id) {
          return {
            ...user,
            tasks: user.tasks + 1,
            pendingTasks: user.pendingTasks + 1, // New task is pending
          };
        }
        return user;
      });

      const newActivity = {
        id: `act${Date.now()}`,
        text: `New '${taskDetails.priority}' priority task assigned to ${taskDetails.assignedToUser.name}: '${taskDetails.documentName}' for '${taskDetails.projectName}'. Due: ${taskDetails.dueDate}`,
        time: 'Just now',
      };

      return {
        ...prevData,
        userWorkload: updatedUserWorkload,
        recentActivity: [newActivity, ...prevData.recentActivity].slice(0, 5),
      };
    });
  };
  // Calculate user with least tasks
  const userWithLeastTasks = dashboardData.userWorkload.reduce((minUser, currentUser) => {
    return currentUser.tasks < minUser.tasks ? currentUser : minUser;
  }, dashboardData.userWorkload[0]);

  // Calculate task progress for "My Assigned Tasks"
  const myAssignedTasksTotal = dashboardData.tasks.assignedToMe.total;
  const myAssignedTasksCompleted = dashboardData.tasks.assignedToMe.statusCounts.approved;
  const myAssignedTasksPending = dashboardData.tasks.assignedToMe.statusCounts.onHold;
  const myAssignedTaskType = dashboardData.tasks.assignedToMe.task_type;




  return (
    <div className="min-h-screen bg-gray-100 p-1 sm:p-1 lg:p-1 font-inter">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
        {userRole == 1 &&
          <DashboardCard
            title="Non-Litigation Projects"
            value={dashboardData.projects.nonLitigation.totalProjects}
            // subtitle="Total Projects"
            icon={FaBalanceScale}
            link={() => store.navTo(`/${URLPRIFIX}/projects/list`)} // Example path
          >
            <div className="text-sm" style={{ color: '#4B5563' }}> {/* gray-600 */}
              <p><span className="font-medium" style={{ color: '#16A34A' }}>{dashboardData.projects.nonLitigation.documentsCompleted}</span> Documents Completed</p> {/* green-600 */}
              <p><span className="font-medium" style={{ color: '#2563EB' }}>{dashboardData.projects.nonLitigation.taskDraft}</span> Tasks in Draft</p> {/* yellow-500 */}
              <p><span className="font-medium" style={{ color: '#EAB308' }}>{dashboardData.projects.nonLitigation.tasksPending}</span> Tasks Inprogress</p> {/* blue-600 */}
              <p><span className="font-medium" style={{ color: '#16A34A' }}>{dashboardData.projects.nonLitigation.tasksCompleted}</span> Tasks Completed</p> {/* yellow-500 */}

            </div>

          </DashboardCard>
        }

        {userRole == 1 &&
          <DashboardCard
            title="Litigation Cases"
            value={dashboardData.projects.litigation.totalProjects}
            // subtitle="Total Cases"
            icon={TbHammer}
            link={() => store.navTo(`/${URLPRIFIX}/litigation/projects/list`)} // Example path
          >
            <div className="text-sm" style={{ color: '#4B5563' }}> {/* gray-600 */}
              <p><span className="font-medium" style={{ color: '#16A34A' }}>{dashboardData.projects.litigation.statusCounts.approved}</span> Approved/Won Cases</p> {/* green-600 */}
              <p><span className="font-medium" style={{ color: '#2563EB' }}>{dashboardData.projects.litigation.statusCounts.open}</span> Open Cases</p> {/* blue-600 */}
              <p><span className="font-medium" style={{ color: '#DC2626' }}>{dashboardData.projects.litigation.statusCounts.onHold}</span> Cases On Hold</p> {/* red-600 */}
            </div>

          </DashboardCard>

        }
        {userRole == 1 &&
          <DashboardCard
            title="Trademark Registrations"
            value={dashboardData.projects.trademark.totalProjects}
            // subtitle="Total Registrations"
            icon={FaShieldAlt}
            link={() => store.navTo(`/${URLPRIFIX}/trademark/projects/list`)} // Example path

          >
            <div className="text-sm" style={{ color: '#4B5563' }}> {/* gray-600 */}
              <p><span className="font-medium" style={{ color: '#16A34A' }}>{dashboardData.projects.trademark.statusCounts.approved}</span> Approved Registrations</p> {/* green-600 */}
              <p><span className="font-medium" style={{ color: '#2563EB' }}>{dashboardData.projects.trademark.statusCounts.open}</span> Filed Applications</p> {/* blue-600 */}
              <p><span className="font-medium" style={{ color: '#DC2626' }}>{dashboardData.projects.trademark.statusCounts.rejected}</span> Rejected Applications</p> {/* red-600 */}
            </div>

          </DashboardCard>
        }

        <DashboardCard
          title="My Assigned Tasks"
          value={myAssignedTasksTotal}
          subtitle="Tasks assigned to you"
          icon={FaClipboardList}

          link={() => {
            if (myAssignedTaskType === 11) {
              store.removemodule("nonlitigation_task");
              store.navTo(`/demo/tasks/list/${user.id}`);
            } else if (myAssignedTaskType === 12) {
              store.removemodule("litigation_task");
              store.navTo(`/demo/litigation/tasks/list/${user.id}`);
            } else {
              store.removemodule("trademark_task");
              store.navTo(`/demo/trademark/tasks/list/${user.id}`);
            }
          }}
        >
          <div className="flex items-center justify-between text-sm" style={{ color: '#4B5563' }}> {/* gray-600 */}
            <p className="flex items-center"><FaCheckCircle className="w-4 h-4 mr-1" style={{ color: '#22C55E' }} /> Completed: <span className="font-medium ml-1">{myAssignedTasksCompleted}</span></p> {/* green-500 */}
            <p className="flex items-center"><FaHourglassHalf className="w-4 h-4 mr-1" style={{ color: '#EAB308' }} /> Pending: <span className="font-medium ml-1">{myAssignedTasksPending}</span></p> {/* yellow-500 */}
          </div>
          <div className="h-2 rounded-full mt-3 overflow-hidden" style={{ backgroundColor: '#E5E7EB' }}> {/* gray-200 */}
            <div
              className="h-full rounded-full"
              style={{ backgroundColor: '#22C55E', width: `${(myAssignedTasksCompleted / myAssignedTasksTotal) * 100 || 0}%` }} // green-500
            ></div>
          </div>

        </DashboardCard>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-2 gap-6">

        <DashboardCard
          title="Upcoming Deadlines"
          subtitle="Critical tasks requiring immediate attention"
          icon={FaCalendarCheck}
          className="lg:col-span-1"
        >
          <ul className="space-y-3 mt-4">
            {dashboardData.upcomingDeadlines.length > 0 ? (
              dashboardData.upcomingDeadlines.map(deadline => (
                <li key={deadline.id} className="flex items-center justify-between p-3 rounded-lg" style={{ backgroundColor: '#F9FAFB', border: '1px solid #E5E7EB' }}>
                  <div>
                    <p className="font-medium" style={{ color: '#1F2937' }}>{deadline.title}</p>
                    <p className="text-sm" style={{ color: '#4B5563' }}>
                      <span className="font-semibold">{deadline.project}</span> | Due: {new Date(deadline.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </p>
                  </div>
                  <div className="flex items-center text-sm" style={{ color: '#6B7280' }}>
                    <FaUsers className="w-4 h-4 mr-1" /> {deadline.assignedTo}
                  </div>
                </li>
              ))
            ) : (
              <p style={{ color: '#6B7280' }}>No upcoming deadlines.</p>
            )}
          </ul>
          {/* <a href="#" className="mt-4 font-medium self-end flex items-center" style={{ color: '#2563EB' }}> 
              View All Deadlines <FaArrowRight className="ml-1 w-4 h-4" />
            </a> */}
        </DashboardCard>


        {userRole == 1 &&
          <DashboardCard
            title={
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center space-x-3">
                  {/* <FaUsers className="text-xl text-blue-800" /> */}
                  <h2 className="text-lg font-semibold text-gray-800">Users Workload Distribution</h2>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div className="relative">
                  <input
                    type="text"
                    placeholder="search users..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="px-2 text-xs items-right rounded-md border border-gray-300 shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-300"
                    style={{ backgroundColor: '#F9FAFB', color: '#1F2937', width: '130px' }}
                  />
                  {/* <span className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none text-gray-400">
                <svg className="h-4 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" ><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path> search</svg>
              </span> */}
                </div>
              </div>
            }
            subtitle={
              <div className="flex items-center">
                Identify available resources for new assignments
                <div className="flex ml-4 space-x-2">
                  <div className="relative group">
                    <span className="w-3 h-3 bg-[#d6eaf8] rounded-full inline-block cursor-pointer border border-[#21618c]"></span>
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">Draft</div>
                  </div>
                  {/* <div className="relative group">
                  <span className="w-3 h-3 bg-[#E6F4EA] rounded-full inline-block cursor-pointer border border-[#188038]"></span>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">Draft</div>
                </div> */}
                  <div className="relative group">
                    <span className="w-3 h-3 bg-[#f9e79f] rounded-full inline-block cursor-pointer border border-[#b7950b]"></span>
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">In Progress</div>
                  </div>
                  {/* <div className="relative group">
                  <span className="w-3 h-3 bg-[#f9e79f] rounded-full inline-block cursor-pointer border border-[#b7950b]"></span>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">Waiting for Approval</div>
                </div> */}
                </div>
              </div>
            } icon={FaUsers}
            className="overflow-hidden"
          >


            <div className="max-h-[410px] overflow-y-auto custom-scrollbar pr-2"> {/* Added pr-2 for scrollbar spacing */}
              <ul className="space-y-3 mt-4">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map(user => (
                    <li key={user.id} className={`flex items-center justify-between p-3 rounded-lg ${user.id === userWithLeastTasks.id ? '' : ''}`}
                      style={{
                        backgroundColor: user.id === userWithLeastTasks.id ? '#EFF6FF' : '#F9FAFB', // blue-50 : gray-50
                        border: user.id === userWithLeastTasks.id ? '1px solid #BFDBFE' : '1px solid #E5E7EB' // blue-200 : gray-200
                      }}>
                      <div className="flex items-center">
                        <img src={`https://placehold.co/40x40/e0e7ff/3b82f6?text=${user.initials}`} alt={user.name} className="w-8 h-8 rounded-full mr-3" style={{ border: '1px solid #93C5FD' }} /> {/* blue-300 */}
                        <span className="font-medium" style={{ color: '#374151' }}>{user.name}</span> {/* gray-700 */}
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className={`px-3 py-1 rounded-full text-sm font-semibold`}
                          style={{
                            backgroundColor: user.id === userWithLeastTasks.id ? '#2563EB' : '#DBEAFE', // blue-600 : blue-100
                            color: user.id === userWithLeastTasks.id ? '#FFFFFF' : '#1E40AF' // white : blue-800
                          }}>
                          {user.tasks}
                        </span>
                        <span className={`px-3 py-1 rounded-full text-sm font-semibold`}
                          style={{
                            backgroundColor: '#f9e79f', // from user's snippet
                            color: '#212f3d' // from user's snippet
                          }}>
                          {user.draft}
                        </span>
                        {/* <span className={`px-3 py-1 rounded-full text-sm font-semibold`}
                            style={{
                              backgroundColor: user.pendingTasks > 0 ? '#FEF3C7' : '#D1FAE5', // yellow-100 : green-100
                              color: user.pendingTasks > 0 ? '#92400E' : '#065F46' // yellow-800 : green-800
                            }}>
                        {user.pendingTasks} Pending
                      </span> */}
                        {/* <span className={`px-3 py-1 rounded-full text-sm font-semibold`}
                            style={{
                              backgroundColor: '#E6F4EA', // from user's snippet
                              color: '#188038' // from user's snippet
                            }}>
                        {user.completedTasks} 
                      </span> */}
                        <button
                          onClick={() => handleAssignTaskClick(user)} // Open modal on click
                          className="px-3 py-1 rounded-full text-sm font-semibold"
                          style={{ backgroundColor: '#2563EB', color: '#FFFFFF', cursor: 'pointer' }} // blue-600, white
                        >
                          +
                        </button>
                      </div>
                    </li>
                  ))
                ) : (
                  <p style={{ color: '#6B7280' }}>No users found matching your search.</p>
                )}
              </ul>
            </div>
            {/* <a href="#" className="mt-4 font-medium self-end flex items-center" style={{ color: '#2563EB' }}> 
              Manage User Assignments <span className="ml-1">→</span>
            </a> */}
          </DashboardCard>
        }


        {/* Accounting Summary */}
        {userRole == 1 &&
          <DashboardCard
            title="Accounting Summary"
            subtitle="Financial overview for the current period"
            icon={FaDollarSign}
            className="lg:col-span-1 h-290"
          >
            <div className="space-y-2 mt-4" style={{ color: '#374151' }} >
              <p className="flex justify-between items-center text-lg font-semibold">
                Total Invoiced: <span style={{ color: '#275bebff' }}>
                  {dashboardData.accountingSummary.totalInvoiced.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR"
                  })}
                </span>
              </p>
              <p className="flex justify-between items-center">
                Amount Received: <span className="font-medium" style={{ color: '#3f4316ff' }}>
                  {dashboardData.accountingSummary.amountReceived.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR"
                  })}
                </span>
              </p>

              <p className="flex justify-between items-center">
                Outstanding Balance: <span className="font-medium" style={{ color: '#197e04ff' }}>
                  {dashboardData.accountingSummary.outstandingBalance.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR"
                  })}
                </span>
              </p>
            </div>
            <div className="mt-6">
              <h4 className="text-md font-semibold mb-3" style={{ color: '#1F2937' }}>Top Clients</h4>
              <ul className="space-y-2 text-sm" style={{ color: '#4B5563' }}>
                {dashboardData.accountingSummary.topClients.map(client => (
                  <li key={client.id} className="flex justify-between items-center">
                    <span>{client.name}</span>
                    <span className="font-medium">{client.amount.toLocaleString("en-IN",
                      {
                        style: "currency",
                        currency: "INR"
                      }
                    )}</span>
                  </li>
                ))}
              </ul>
            </div>
            {/* <a href="#" className="mt-4 font-medium self-end flex items-center" style={{ color: '#2563EB' }}> 
              View Full Report <FaArrowRight className="ml-1 w-4 h-4" />
            </a> */}
          </DashboardCard>
        }

        {/* Recent Activity */}
        {userRole == 1 &&
          <DashboardCard
            title="Recent Activity"
            subtitle="Latest actions across the platform"
            icon={FaRegChartBar}
            className="lg:col-span-1 h-290"
          >
            <ul className="space-y-3 mt-4">
              {dashboardData.recentActivity.length > 0 ? (
                dashboardData.recentActivity.map(activity => (
                  <li key={activity.id} className="flex items-start p-3 rounded-lg" style={{ backgroundColor: '#F9FAFB', border: '1px solid #E5E7EB' }}>
                    <FaRegDotCircle className="w-4 h-4 mt-1 mr-3 flex-shrink-0" style={{ color: '#9CA3AF' }} />
                    <div>
                      <p style={{ color: '#1F2937' }}>{activity.text}</p>
                      <p className="text-xs mt-1" style={{ color: '#6B7280' }}>{activity.time}</p>
                    </div>
                  </li>
                ))
              ) : (
                <p style={{ color: '#6B7280' }}>No recent activity.</p>
              )}
            </ul>
            {/* <a href="#" className="mt-4 font-medium self-end flex items-center" style={{ color: '#2563EB' }}> 
            View All Activity <FaArrowRight className="ml-1 w-4 h-4" />
          </a> */}
          </DashboardCard>
        }
      </div>

      {/* Custom Scrollbar Style */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
      <AssignTaskModal
        isOpen={isAssignModalOpen}
        onClose={() => setIsAssignModalOpen(false)}
        onSubmit={handleTaskSubmit}
        assignedToUser={selectedUserForAssignment}
      />
    </div>
  );
};


export default DashboardNew;
